// extracted by mini-css-extract-plugin
module.exports = {"title":"NTr57S","enableSliderTeaser":"eksMRV","withHideArrows":"_8_gK6"};